// @flow
import { useState, useEffect } from 'react';
import {
  startTiming,
  stopTiming,
  logCustomTraceEvent,
} from 'app/common/lib/TraceLogger/logTraceEvent';

const useGridBottomSpinnerProfiler = ({
  isFetching,
  viewParameterType,
}: {|
  isFetching: boolean,
  viewParameterType: $Values<PCONST.thrift.ViewParameterType>,
|}) => {
  const [recording, setRecording] = useState(false);
  useEffect(
    () => {
      if (recording && !isFetching) {
        setRecording(false);
        stopTiming(PCONST.thrift.TracingClientTypes.PWTAction.GRID_BOTTOM_SPINNER, {
          viewParameter: viewParameterType,
        });
        logCustomTraceEvent({ name: 'GridBottomSpinnerStoppedTraceEvent' });
      }
    },
    [recording, isFetching],
  );

  const startGridBottomSpinnerTiming = () => {
    if (isFetching) {
      return;
    }
    setRecording(true);
    startTiming(PCONST.thrift.TracingClientTypes.PWTAction.GRID_BOTTOM_SPINNER);
    logCustomTraceEvent({ name: 'GridBottomSpinnerStartedTraceEvent' });
  };

  return startGridBottomSpinnerTiming;
};

export default useGridBottomSpinnerProfiler;
